export { default as Loader } from "./Loader";
export { default as QueryLoader } from "./QueryLoader";
